import { v4 } from "uuid";

export default function createAction(type, payload, id) {
  return {
    id: id || v4(),
    type,
    payload,
  };
}
